import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuthStore } from '../services/auth';
import { useBookmarkStore } from '../stores/bookmarkStore';
import { useStore } from '../store';

export default function AuthCallback() {
  const navigate = useNavigate();
  const setUser = useAuthStore(state => state.setUser);
  const setSession = useAuthStore(state => state.setSession);
  const setShowAuthModal = useAuthStore(state => state.setShowAuthModal);
  const loadBookmark = useBookmarkStore(state => state.loadBookmark);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get the session from the URL
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Auth callback error:', error.message);
          return;
        }

        if (session) {
          // Set the session in the auth store
          setUser(session.user);
          setSession(session);
          setShowAuthModal(false);

          // Load bookmark first
          await loadBookmark();
          
          // Store session in localStorage for persistence
          localStorage.setItem('divine-intelligence-auth-session', JSON.stringify(session));
          
          // Navigate to home page
          navigate('/', { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      } catch (error) {
        console.error('Error in auth callback:', error);
        navigate('/', { replace: true });
      }
    };

    handleCallback();
  }, [navigate, setUser, setSession, setShowAuthModal, loadBookmark]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-obsidian-900">
      <div className="text-center">
        <h2 className="text-2xl font-semibold mb-4 text-gold-200">Completing sign in...</h2>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gold-500 mx-auto"></div>
      </div>
    </div>
  );
}
